import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=cdfa32c6&scoped=true"
import script from "./Servicios.js?vue&type=script&lang=js&external"
export * from "./Servicios.js?vue&type=script&lang=js&external"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=cdfa32c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa32c6",
  null
  
)

export default component.exports